import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'

interface MonthRow {
  key: string
  label: string
  income: number
  expenses: number
  net: number
}

interface Props {
  rows: MonthRow[]
}

const usd = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })
const usdShort = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', notation: 'compact', maximumFractionDigits: 1 })

export function IncomeExpenseChart({ rows }: Props) {
  return (
    <div className="rounded-xl border border-zinc-200 p-4 dark:border-zinc-800">
      <div className="mb-2 flex items-center justify-between">
        <h2 className="text-sm font-medium">Income vs expense (last 12 months)</h2>
      </div>
      <div className="h-[280px]">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={rows} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e4e4e7" />
            <XAxis dataKey="label" tick={{ fontSize: 11 }} />
            <YAxis tick={{ fontSize: 11 }} tickFormatter={(v: number) => usdShort.format(v)} width={60} />
            <Tooltip
              formatter={(value, name) => [
                typeof value === 'number' ? usd.format(value) : String(value),
                String(name),
              ]}
              contentStyle={{ borderRadius: 8, border: 'none', fontSize: 12 }}
            />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            <Bar dataKey="income" name="Income" fill="#16a34a" radius={[4, 4, 0, 0]} />
            <Bar dataKey="expenses" name="Expenses" fill="#dc2626" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  )
}
